import axios from 'axios';
import { SERVER_URL, RECRUITMENT_URL, ADMIN_SERVER_URL } from './Config';
import { getPreviewToken, getToken, removePreviewToken } from './Token';
import { store } from '../redux/storeConfig/store';
export const getRequestFromRecruit = async (url) => {
  const tokenLogin = await getToken();
  return axios({
    method: 'GET',
    url: RECRUITMENT_URL + url,
    headers: { Authorization: tokenLogin },
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

export const postRequestFromRecruit = async (url, params) => {
  const tokenLogin = await getToken();
  return axios({
    method: 'POST',
    url: RECRUITMENT_URL + url,
    headers: { Authorization: tokenLogin },
    data: params,
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

export const getRequest = (url) => {
  return axios.get(SERVER_URL + url).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};
export const postRequest = (url, params) => {
  return axios.post(SERVER_URL + url, params).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

export const postRequestWithToken = async (
  url,
  params,
  responseType = 'json' //default response type that is expected. arraybuffer response type is needed for excel report
) => {
  const tokenPreview = await getPreviewToken();
  const tokenLogin = await getToken();
  let token = tokenPreview ? tokenPreview : tokenLogin;
  return axios({
    method: 'POST',
    url: SERVER_URL + url,
    headers: { Authorization: token },
    data: params,
    responseType,
  }).then((response) => {
    if (response.data.error) {
      removePreviewToken();
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};
export const putRequestWithToken = async (url, params) => {
  const tokenPreview = await getPreviewToken();
  const tokenLogin = await getToken();
  let token = tokenPreview ? tokenPreview : tokenLogin;
  return axios({
    method: 'PUT',
    url: SERVER_URL + url,
    headers: { Authorization: token },
    data: params,
  }).then((response) => {
    if (response.data.error) {
      removePreviewToken();
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

export const getRequestWithToken = async (url, data) => {
  const tokenPreview = await getPreviewToken();
  const tokenLogin = await getToken();
  let token = tokenPreview ? tokenPreview : tokenLogin;
  console.log(data, 'data');
  return axios({
    method: 'GET',
    url: SERVER_URL + url,
    params: data,
    headers: { Authorization: token },
  }).then((response) => {
    if (response.data.error) {
      removePreviewToken();
      throw response.data.error;
    } else {
      //console.log('data', response.data);
      return response.data;
    }
  });
};

export const getRequestWithAdminAPI = async (url) => {
  const tokenPreview = await getPreviewToken();
  const tokenLogin = await getToken();
  let token = tokenPreview ? tokenPreview : tokenLogin;
  return axios({
    method: 'GET',
    url: ADMIN_SERVER_URL + url,
    headers: { Authorization: token },
  }).then((response) => {
    if (response.data.error) {
      removePreviewToken();
      throw response.data.error;
    } else {
      //console.log('data', response.data);
      return response.data;
    }
  });
};

export const putRequestMultipart = async (url, params) => {
  const tokenPreview = await getPreviewToken();
  const tokenLogin = await getToken();
  let token = tokenPreview ? tokenPreview : tokenLogin;
  return axios({
    method: 'PUT',
    url: SERVER_URL + url,
    headers: { Authorization: token, 'Content-Type': 'multipart/form-data' },
    data: params,
  }).then((response) => {
    if (response.data.error) {
      removePreviewToken();
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};
export const postRequestMultipart = async (url, params) => {
  const tokenPreview = await getPreviewToken();
  const tokenLogin = await getToken();

  let token = tokenPreview ? tokenPreview : tokenLogin;

  return axios({
    method: 'POST',
    url: SERVER_URL + url,
    headers: { Authorization: token, 'Content-Type': 'multipart/form-data' },
    data: params,
  }).then((response) => {
    if (response.data.error) {
      removePreviewToken();
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};
export const deleteRequestWithToken = async (url) => {
  const tokenPreview = await getPreviewToken();
  const tokenLogin = await getToken();
  let token = tokenPreview ? tokenPreview : tokenLogin;
  return axios({
    method: 'DELETE',
    url: SERVER_URL + url,
    headers: { Authorization: token },
  }).then((response) => {
    if (response.data.error) {
      removePreviewToken();
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

function InterceptorsRequest(config) {
  config.headers['Content-Type'] = 'application/json';
  // console.log(
  //   'API_REQUEST:\n URL:',
  //   config.url,
  //   '\nAuthorization:',
  //   config.headers.Authorization,
  //   '\nBody:',
  //   JSON.stringify(config.data)
  // );
  return config;
}

const _handleCommonError = (errorResponse) => {
  // TODO: Handle Error
  if (errorResponse.message) {
  }
};

const _interceptorsResponseError = (error) => {
  if (error && error.response && error.response.status)
    switch (error.response.status) {
      case 401:
        // removeToken();
        // will redirect to "login" when Unauthorised error will raise
        // navigateFromOutside.navigate('LoginScreen', 'Login');
        const dispatch = store.dispatch;
        dispatch({ type: 'LOGOUT_WITH_JWT', payload: {} });
        break;
      default:
        _handleCommonError(error);
        break;
    }
  else {
    //  alert(error);
  }
};

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    return InterceptorsRequest(config);
  },
  (error) => {
    console.log('API_REQUEST_ERROR:', error);
    _interceptorsResponseError(error);
    return Promise.reject(error.response);
  }
);

// // Add a response interceptor
// axios.interceptors.response.use(
//   (response) => {
//     console.log(
//       '\n\nAPI_RESPONSE:\nStatus:',
//       // response.status,
//       '\nData:',
//       response.data,
//       '\n\n'
//     );
//     return response;
//   },
//   (error) => {
//     console.log('API_RESPONSE_ERROR', JSON.stringify(error), 'asdads');
//     _interceptorsResponseError(error);
//     return Promise.reject(error);
//   }
// );
